import axios, { AxiosError, AxiosResponse } from "axios";
import { showToast } from "../components/common/toastNotification";

const API_URL = process.env.REACT_APP_API_URL;

export const httpTokenCommon = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const httpTokenFileUpload = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
export const httpTokenFileDownload = axios.create({
  baseURL: API_URL,
  responseType: "blob",
});

// Request Interceptor for Adding Token
httpTokenCommon.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
httpTokenFileUpload.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
httpTokenFileDownload.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// Centralized Error Handling Function
const handleApiError = (error: AxiosError) => {
  if (error.response) {
    const { status, data } = error.response as AxiosResponse<{
      message?: string;
      error?: string;
    }>;

    const errorMessage =
      data?.message || data?.error || "An unexpected error occurred.";

    switch (status) {
      case 400:
        showToast(errorMessage, "error");
        break;
      case 401:
        if (!localStorage.getItem("session_expired_flag")) {
          showToast("Session expired. Please log in again.", "error");
          localStorage.setItem("session_expired_flag", "true");

          setTimeout(() => {
            localStorage.clear();
            window.location.href = "/";
          }, 2000);
        }
        break;

      case 404:
        showToast(errorMessage, "error");
        break;
      case 500:
        showToast(
          "Server is currently unavailable. Please try again later.",
          "error"
        );
        break;
      default:
        showToast(errorMessage, "error");
    }
  } else {
    showToast("Network error. Please check your connection.", "error");
  }
  return Promise.reject(error);
};

// Response Interceptor for Error Handling
httpTokenCommon.interceptors.response.use(
  (response) => response,
  handleApiError
);

httpTokenFileUpload.interceptors.response.use(
  (response) => response,
  handleApiError
);
